import React from "react";
var __jsx = React.createElement;
import stl from "./USP.module.css";
export var USP = function USP(_ref) {
  var usp = _ref.usp;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.uspContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: usp.image,
    alt: usp.title,
    width: "150px",
    height: "200px",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("h3", null, usp.title), /*#__PURE__*/React.createElement("p", null, usp.desc));
};